module.exports = __webpack_public_path__ + "static/media/guide_Page_10.9667af72.png";